﻿(function () {
    "use strict";

    angular
        .module("app")
        .component("linkQboEntity", {
            bindings: {
                component: "=?",
                modalTarget: "@",
                entityType: "@",
                displayName: "@",
                apiGet: "@",
                apiGetDisableCache: "=",
                apiUpdate: "@?",
                apiUnlink: "@?",
                multiple: "@",
                entityId: "@",
                qboId: "@",
                qboName: "@",

                linkButtonText: "@?",
                linkUpdateButtonText: "@?",
                showUpdateDetails: "@?",

                onTransformData: "&?",
                onLink: "&?",
                onLinkSuccess: "&?",
                onLinkError: "&?",
                onUnlinkSuccess: "&?",
                onUnlinkError: "&?",
                onCreate: "&?"
            },
            templateUrl: ['version', function (version) {
                return `/js/components/linkQboEntity/linkQboEntity.html?v=${version}`
            }],
            transclude: {
                'itemTemplate': '?itemTemplate'
            },
            controller: LinkQboEntityController,
            controllerAs: "vm"
        });

    LinkQboEntityController.$inject = ["$scope", "$rootScope", "request", "$timeout"];

    function LinkQboEntityController($scope, $rootScope, request, $timeout) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$postLink = postLink;

        vm.popupId = "popup-" + $scope.$id;
        vm.target;
        vm.selected = selected;
        vm.selectedMultiple = selectedMultiple;
        vm.unlink = unlink;
        vm.create = create;

        vm.show = showPopup;
        vm.getSelectedCount = getSelectedCount;
        vm.select = select;
        vm.selectAll = selectAll;

        vm.notificationDuration = 0
        vm.notificationType = ''
        vm.notificationMessage = ''
        vm.notificationOnClose = () => {
          vm.notificationMessage = ''
        }

        function showNotification(duration, type, message) {
            vm.notificationDuration = duration
            vm.notificationType = type
            vm.notificationMessage = message
            vm.notificationNonce = Math.random()
        }

        vm.entity = {
            name: '',
            search: '',
            qboItems: [],
            qboItemsLoading: false,
            data: null
        };

        function onInit() {
            vm.multiple = vm.multiple == 'true' || false;
            vm.linkButtonText = vm.linkButtonText || 'Link';
            vm.linkUpdateButtonText = vm.linkUpdateButtonText || 'Link & Update Info';
            vm.showUpdateDetails = vm.showUpdateDetails == 'true' || false;

            vm.component = vm;
        }

        function postLink() {
            if (vm.modalTarget) {
                $timeout(function () {
                    $(vm.modalTarget).on("click", function (e) {
                        vm.target = $(e.currentTarget);
                        showPopup();
                        $scope.$apply();
                    });
                }, 2000)
            }
        }

        function showPopup() {
            vm.entity.id = vm.entityId;
            vm.entity.name = vm.displayName;
            vm.entity.data = vm.multiple ? {} : null;

            vm.entity.search = vm.qboName || '';

            $("#" + vm.popupId).modal();

            if ((!vm.entity.qboItems.length || vm.apiGetDisableCache) && !vm.entity.qboItemsLoading) {
                vm.entity.qboItemsLoading = true;

                request.get($rootScope.apiEndpoint + vm.apiGet).then(
                    function (response) {
                        vm.entity.qboItems = response.data;
                        vm.entity.data = vm.entity.qboItems.find(i => i.id === vm.qboId);
                        vm.entity.qboItemsLoading = false;
                    },
                    function () {
                        vm.entity.qboItems = [];
                        vm.entity.qboItemsLoading = false;
                        showNotification(5, 'Error', `There was an error getting the ${vm.entityType}s from QuickBooks`)
                    });

            } else {
                vm.entity.data = vm.entity.qboItems.find(i => i.id === vm.qboId);
            }
        }

        function getSelectedCount() {
            const items = document.querySelectorAll('.link-qbo__multiple .link-qbo__items input[type=checkbox]:checked');

            return items.length;
        }

        function select(e, id) {
            e.stopImmediatePropagation();
            e.preventDefault();

            const item = document.querySelector(`#link-qbo__item--${id}`);
            item.checked = !item.checked;
        }

        function selectAll() {
            const value = document.querySelector('#link-qbo__item--all').checked;

            const items = document.querySelectorAll('.link-qbo__multiple .link-qbo__items input[type=checkbox]');
            items.forEach(i => i.checked = value);
        }

        async function selected(updateDetails = false) {
            if (!vm.entity.data)
                return;

            try {
                vm.entity.qboUpdating = true;

                if (vm.onTransformData) {
                    vm.entity.data = vm.onTransformData({ data: vm.entity.data });
                }

                if (vm.onLink) {
                    await vm.onLink({ data: vm.entity.data, updateDetails });
                }

                if (vm.apiUpdate) {
                    request.post($rootScope.apiEndpoint + vm.apiUpdate, vm.entity.data).then(function () {
                        if (vm.onLinkSuccess) {
                            vm.onLinkSuccess({ data: vm.entity.data });
                        }
                    }, function (e) {
                        showNotification(5, 'Error', `Could not update the ${vm.entityType}`)
                        if (vm.onLinkError) {
                            vm.onLinkError(e);
                        }
                    });
                }

            } catch (e) {
                showNotification(5, 'Error', `Could not update the ${vm.entityType}`)
                if (vm.onLinkError) {
                    vm.onLinkError(e);
                }

            } finally {
                vm.entity.qboUpdating = false;
                $("#" + vm.popupId).modal("hide");
            }
        }

        async function unlink() {
            if (vm.apiUnlink) {
                request.post($rootScope.apiEndpoint + vm.apiUnlink, vm.entityId).then(function () {
                    vm.entity.search = '';
                    if (vm.onUnlinkSuccess) {
                        vm.onUnlinkSuccess();
                    }
                }, function (e) {
                    showNotification(5, 'Error', `Could not unlink the ${vm.entityType}`)
                    if (vm.onUnlinkError) {
                        vm.onUnLinkError(e);
                    }
                });
            }
        }

        async function create() {
            if (vm.onCreate) {
                const result = vm.onCreate();
                if (result && typeof result.then === 'function') {
                    result.then(function (result) {
                        $("#" + vm.popupId).modal("hide");
                        vm.entity.qboItems.push({ id: result.qboId, displayName: result.qboDisplayName });
                        setTimeout(function () {
                            showNotification(5, 'Success', `The ${vm.entityType} was successfully created in QuickBooks`)
                        }, 500);
                    })
                    .catch((error) => {
                        showNotification(5, 'Error', error.data.message)
                    });
                }
            }
        }

        async function selectedMultiple() {
            const items = Array.from(document.querySelectorAll('.link-qbo__multiple .link-qbo__items input[type=checkbox]:checked'));
            let id;
            let dataEntity;

            vm.entity.data = [];

            items.forEach(i => {
                id = i.getAttribute('data-entityid');
                dataEntity = vm.entity.qboItems.find(e => e.id === id);
                if (dataEntity) {
                    vm.entity.data.push(dataEntity);
                }
            });

            selected();
        }
    }

})();